<template>
  <FormSubmitPopup
    :title="title"
    @popupClose="$emit('input', false)"
    v-model="value"
    ref="formPopup"
    :rightMethod="onSubmitted"
    :rightButtonText="$t('submit')"
    medium
  >
    <template v-slot:input>
      <v-container>
        <v-card>
          <v-card-title>
            <h3>{{ $t('unitCubicInchHint') }}</h3>
          </v-card-title>

          <v-card-text class="pb-0">
            <v-list>
              <div v-for="(scope, index) in billingWeightScope" :key="index">
                <v-list-tile-content>
                  <v-layout>
                    <v-text-field
                      v-model.number="scope.start"
                      :rules="[
                        getScopeValidator('start', billingWeightScope, Number(index), 0)
                      ]"
                      :disabled="index !== billingWeightScope.length - 1"
                      :label="$t('startDay')"
                      class="required_field"
                    ></v-text-field>
                    <v-flex pt-3 px-2><span>&lt; X ≤</span></v-flex>
                    <v-text-field
                      style="width: 167px;"
                      v-model.number="scope.end"
                      :rules="[
                        getScopeValidator('end', billingWeightScope, Number(index), 1),
                      ]"
                      name="end"
                      :disabled="index !== billingWeightScope.length - 1"
                      class="required_field"
                      :label="$t('endDay')"
                    >
                    <template v-slot:append>
                      <v-icon @click="setInfinity(scope)"  v-if="index === billingWeightScope.length - 1" color="primary">all_inclusive</v-icon>
                    </template>
                    </v-text-field>
                    <v-text-field
                      v-model.number="scope.price"
                      :label="$t('price')"
                      prefix="$"
                      class="required_field pl-2"
                      :hint="$t('unitCubicInchHint')"
                      :rules="[fieldIsRequired(), fieldIsNoLessThanZero(), fieldIsNumber()]"
                    ></v-text-field>
                    <v-flex class="text-xs-right">
                      <v-btn @click="removeScope(index)" v-if="index === billingWeightScope.length -1 && index > 0" icon><v-icon>delete</v-icon></v-btn>
                    </v-flex>
                  </v-layout>
                </v-list-tile-content>
              </div>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-layout>
              <v-flex>
                <v-btn color="primary" @click="addScope(billingWeightScope)">{{ $t('add') }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import UploadFileWidget from './UploadFileWidget'
import { checkRules } from '@/utils/tools'

export default {
  name: 'StageStorageFeePopup',
  components: { FormSubmitPopup, UploadFileWidget },
  mixins: [checkRules],
  data () {
    return {
      attachments: [],
      removeFilesUponUnmounted: true,
      billingWeightScope: []
    }
  },
  mounted () {
    if (this.detail) {
      this.billingWeightScope = this.detail.map((item) => {
        return {...item}
      })
    }
  },
  computed: {},
  methods: {
    getScopeValidator (field, that, index, scopeCode) {
      return (value) => {
        if (value === undefined || value === '') {
          return `${field}不能为空`
        }
        if (isNaN(value)) {
          return `${field}必须是数字`
        }
        if (value !== parseInt(value) && value !== Infinity) {
          return `${field}必须是整数`
        }
        
        const currentScope = that[index]
        if (scopeCode === 0 && index === 0 && value !== 0) {
          return '起始天数必须等于0'
        }

        if (scopeCode === 0 && currentScope.end <= value) {
          return '开始天数必须小于结束天数'
        }
        if (scopeCode === 1 && currentScope.start >= value) {
          return '结束天数必须大于开始天数'
        }

        if (index > 0 && scopeCode === 0 && that[index - 1].end !== value) {
          return '开始天数必须等于上一个范围的结束天数'
        }

        if (index < that.length - 1 && scopeCode === 1 && that[index + 1].start !== value) {
          return '结束天数必须等于下一个范围的开始天数'
        }
        
        return true
      }
    },
    setInfinity (scope) {
      scope.end = Infinity
    },
    addScope (current) {
      if (!this.$refs['formPopup'].validate()) return
      if (current?.length === 0) {
        current.push({ start: 0, end: 0, price: 0 })
      } else {
        const nextItem = current.at(-1)
        current.push({ start: nextItem.end, end: 0, price: 0 })
      }
      this.$nextTick(() => {
        const endInputs = document.querySelectorAll('input[name="end"]')
        if (endInputs.length === 0) return
        const lastEndInput = endInputs[endInputs.length - 1]
        if (lastEndInput) {
          lastEndInput.focus()
        }
      })
    },
    removeScope (index) {
      this.billingWeightScope.splice(index, 1)
    },
    onSubmitted () {
      if (!this.$refs['formPopup'].validate()) return
      return this.submit(this.billingWeightScope).catch(err => {
        this.$store.dispatch('showToast', {info: err.message, type: 'error'})
        throw err
      })
    }
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      default () {
        return this.$t('popup')
      }
    },
    detail: {
      type: Array,
      default () {
        return []
      }
    },
    submit: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StageStorageFeePopup.vue